import { right } from "@popperjs/core";
import React from "react";

function FooterEdit({ className, children }) {
  return (
    <div
      className={`fixed-bottom container-fluid shadow py-3 bg-white ${className}`}
      style={{ left: 0, right: 0, bottom: 0 }}
    >
      {children}
    </div>
  );
}

export default FooterEdit;
